import React from 'react'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { GetToken, GetUser, GetAccess } from '../../REST/authenticate'
import Access from '../../Utils/authorize'
import { Box, CircularProgress, Typography, Backdrop } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import DefaultSettings from '../../Utils/settings'


export default function SignIn() {
    const { code } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        // Skip if already logged in
        if (Access.user()) {
            navigate('/', { replace: true });
            return;
        }
        
        console.log(code)
        GetToken(code).then(resp => {
            GetUser(resp.data.accessToken).then(res => {
                console.log('user', res.data)
                //console.log('resp', resp)
                const { accessToken, refreshToken, idToken } = resp.data
                Access.setTokens('token', accessToken)
                Access.setTokens('refreshToken', refreshToken)
                Access.setTokens('idToken', idToken)
                Access.setUser(res.data)
                sessionStorage.setItem('expiresIn', new Date().getTime() + 3600 * 1000)
                GetAccess().then(user => {
                    sessionStorage.setItem('access', user.data.access)
                    sessionStorage.setItem('modules', user.data.modules)
                    
                    // Show personalized welcome message only once
                    if (!sessionStorage.getItem('welcomeShown')) {
                        const userName = res.data.given_name && res.data.family_name 
                            ? `${res.data.given_name} ${res.data.family_name}`
                            : res.data.username || 'User';
                        
                        if (DefaultSettings.getAlert()) {
                            DefaultSettings.getAlert().show(`Welcome ${userName}`, 'success');
                        }
                        sessionStorage.setItem('welcomeShown', 'true');
                    }
                    
                    navigate('/', { replace: true })
                }).catch(err => {
                    sessionStorage.clear()
                })
            })
        })
    }, [code, navigate])

    return (
        <Backdrop
            open={true}
            sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 3
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        display: 'inline-flex'
                    }}
                >
                    <CircularProgress
                        size={80}
                        thickness={4}
                        sx={{
                            color: '#673ab7',
                            animationDuration: '1s'
                        }}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <LockIcon sx={{ fontSize: 32, color: '#673ab7' }} />
                    </Box>
                </Box>
                <Typography
                    variant="h6"
                    sx={{
                        color: '#673ab7',
                        fontWeight: 600,
                        letterSpacing: '0.5px'
                    }}
                >
                    Validating Token
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: '#9e9e9e',
                        fontSize: '0.875rem'
                    }}
                >
                    Please wait while we authenticate you...
                </Typography>
            </Box>
        </Backdrop>
    )

}